import CollectionsBootstrap from 'modules/processes/lib/CollectionsBootstrap'
import { Component } from 'modules/processes/pages/Processes/ProcessesHomePage'

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Component />
    </CollectionsBootstrap>
  )
}

export default RootPage
